var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-screen pt-40 lg:pt-0",class:{ 'overflow-hidden': _vm.onMobileMenuOpen }},[_c('Loading',{attrs:{"loading":_vm.loading}}),_c('AsideMenu',{attrs:{"header-menu":_vm.headerMenu}}),_c('div',{staticClass:"relative w-auto m-0 h-full transition-left",class:{ 'lg:ml-70 active': _vm.isOpen }},[_c('header',{staticClass:"w-full fixed top-0 left-0 right-0 lg:relative z-20 bg-white shadow-m",class:[
        _vm.onScrollClass,
        _vm.onMobileMenuOpen
          ? 'h-full overflow-y-auto lg:h-unset lg:overflow-y-unset'
          : null
      ]},[_c('LoggedInHeader'),_c('MobileMenu',{attrs:{"header-menu":_vm.headerMenu}})],1),_vm._t("default"),_c('Footer')],2),_c('Snackbar'),_c('Cookie')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }